module.exports = __webpack_public_path__ + "static/media/crowned-skull.458d8f78.svg";